import { IconType } from "react-icons";

/**
 * IconWrapper
 *
 * Utility function that casts a `react-icons` icon to a valid React SVG component.
 * Useful when you need to treat `IconType` from `react-icons` as a JSX component with SVG props,
 * such as when styling icons or passing them into components expecting `ReactNode`.
 *
 * Props:
 * BsIcon(IconType) - A `react-icons` icon component (e.g., from `react-icons/bs`)
 * @returns {React.ComponentType<React.SVGProps<SVGSVGElement>>} The icon component as a typed SVG element
 *
 * @example
 * ```tsx
 * import { BsChevronRight } from "react-icons/bs";
 * const ChevronIcon = IconWrapper(BsChevronRight);
 *
 * <ChevronIcon style={{ width: 16, height: 16 }} />
 * ```
 */

const IconWrapper = (BsIcon: IconType) => {
    const Icon = BsIcon as React.ComponentType<React.SVGProps<SVGSVGElement>>;

    return Icon;
};

export default IconWrapper;
